import JshModule from '@core/scripts/helper/jsh-module';
import {createRoot} from 'react-dom/client';
import {ContactFormV2} from '@service/scripts/components/contentful/contactform_v2/ContactForm.jsx';

const {moduleScope, config} = JshModule('service/service-page-contact-form-v2');

createRoot(moduleScope).render(
    <ContactFormV2 cdaEntry={config.model}
                   customerData={config.customerData}
                   tenantCountry={config.tenantCountry}
                   friendlyCaptchaEnabled={Boolean(config.friendlyCaptchaEnabled)}
                   friendlyCaptchaSitekeyNewsletter={config.friendlyCaptchaSitekeyNewsletter}
                   friendlyCaptchaSitekeyNewsletterAt={config.friendlyCaptchaSitekeyNewsletterAt} />);
